/* eslint-disable import/no-unresolved */
// ^ no-unresolved gets triggered by '?react' suffix
import React from "react";
import { Flex, HStack } from "@chakra-ui/react";

import AmexSvg from "assets/card-logos/amex.svg?react";
import CUPSvg from "assets/card-logos/cup.svg?react";
import DinersClubSvg from "assets/card-logos/dinersclub.svg?react";
import DiscoverSvg from "assets/card-logos/discover.svg?react";
import JCBSvg from "assets/card-logos/jcb.svg?react";
import MaestroSvg from "assets/card-logos/maestro.svg?react";
import MasterCardSvg from "assets/card-logos/mastercard.svg?react";
import VisaSvg from "assets/card-logos/visa.svg?react";

const SVG_HEIGHT = "20px";

export default function AcceptedCreditCards() {
  return (
    <Flex alignItems="center" justifyContent="flex-start">
      <HStack spacing={2}>
        <AmexSvg height={SVG_HEIGHT} width="auto" title="American Express" />
        <CUPSvg height={SVG_HEIGHT} width="auto" title="China UnionPay" />
        <DinersClubSvg height={SVG_HEIGHT} width="auto" title="Diners Club" />
        <DiscoverSvg height={SVG_HEIGHT} width="auto" title="Discover" />
        <JCBSvg height={SVG_HEIGHT} width="auto" title="JCB" />
        <MaestroSvg height={SVG_HEIGHT} width="auto" title="Maestro" />
        <MasterCardSvg height={SVG_HEIGHT} width="auto" title="MasterCard" />
        <VisaSvg height={SVG_HEIGHT} width="auto" title="Visa" />
      </HStack>
    </Flex>
  );
}
